module.exports = __webpack_public_path__ + "img/emoji-heart-eyes.d3ceadb0.svg";